function List (params) {
  params = params || {};
  
  this.lockout      = false;

  // PARAMS
  this.name               = params.name               || '';
  this.items              = params.items              || [];
  this.noMoreItems        = params.noMoreItems        || false;
  this.loadItemKey        = params.loadItemKey        || 'id';
  this.scroller           = params.scroller           || false;
  this.loaded             = false;
  this.limit              = params.limit              || 25;
  this.params             = params.params             || {};
  this.store              = params.store              || {};
  this.action             = params.action             || '';
  this.requires           = params.requires           || [];
  this.scrollTop          = params.scrollTop          || 0;

  // These are directly applied
  this.sort               = params.sort               || false;
  this.filter             = params.filter             || false;

  // This is the one created by the filters page and parsed
  this.filters            = params.filters            || {};
  
  // MODIFIERS
  this.flip               = params.flip               || false;

  // FUNCTIONS
  this.loadListFunction   = params.loadListFunction   || null;
  this.loadItemFunction   = params.loadItemFunction   || null;
  this.onListLoaded       = params.onListLoaded       || null;
  this.onItemOpened       = params.onItemOpened       || null;
  this.onItemSelected     = params.onItemSelected     || null;
  this.loadItemError      = params.loadItemError      || null;
    
  
  console.log('\n... list:List()', this);
};

List.prototype.loadList = function (params) {
  
  if (this.lockout)  return Promise.reject('List - Busy');
  Vue.set(this, 'lockout', true);
  
  params = params || {};
  
  // NO LOAD LIST FUNCTION
  if (!this.action) {
    Vue.set(this, 'lockout', false);
    Vue.set(this, 'noMoreItems', true);
    Vue.set(this, 'loaded', true);  
    return Promise.reject('List Error: List missing action');
  };
  
  // NO BEFORE, CLEAR LIST
  if (!params.before) {
    Vue.set(this, 'loaded', false);
    Vue.set(this, 'items', []);
    Vue.set(this, 'noMoreItems', false);
  }
  
  // PARSE FILTERS OBJECT
  var filters = this.toFilter(this.filters);

  if (params.filters) {
      for (var key in params.filters) {
      filters[key] = params.filters[key];
    }
  }

  // Filter - Manually set
  if (this.filter) {
    filters = {
      filters,
      ...this.filter
    }
  }

  // Sort - If the user set a manual sort not inside the filters
  if (this.sort) filters.sort = this.sort;
  
  // Add Limit and Offset
  filters.limit = this.limit;
  filters.offset = params.before ? this.items.length : 0;
  
  // Pass Params
  var listParams = {
    ...this.params,
    filters
  };
  
  for (var i = 0; i < this.requires.length; ++i) {
    if (!listParams[this.requires[i]]) {
      this.lockout = false;
      return Promise.reject('List - Missing required param: ' + this.requires[i]);
    }
  }
  
  return AppData.$store.dispatch(this.action, listParams)
  .then((data) => {

    // REVERSE DATA IF REQUIRED BY SORT
    if (filters.sort && filters.sort.charAt(0) !== '-') {
      data.reverse();
    }
    
    // ADD ITEMS TO LIST
    var items = [
      ...this.items
    ];

    var found;
    for (var i = 0; i < data.length; ++i) {
      found = false;
      for (var j = 0; j < items.length; ++j) {
        if (data[i] === items[j]) {
          found = true;
          break;
        }
      }
      if (!found && this.flip) {
        items.unshift(data[i]._id);
      }
      else if (!found) {
        items.push(data[i]._id);
      }
    }

    var scroller;
    if (params.scroller) {
      scroller = {
        scrollHeight: params.scroller.scrollHeight,
        scrollTop: params.scroller.scrollTop
      }
    };
    
    Vue.set(this, 'items', items);
    Vue.set(this, 'noMoreItems', (data.length < filters.limit));
    Vue.set(this, 'loaded', true);
    
    if (this.flip && params.vm) {
      params.vm.$nextTick(function () {
        params.scroller.scrollTop = (params.scroller.scrollHeight - scroller.scrollHeight) + scroller.scrollTop;
        Vue.set(this, 'lockout', false);
        return Promise.resolve(true);
      });
    }
    else {
      Vue.set(this, 'lockout', false);
      return Promise.resolve(true);
    }
  })
  .catch((e) => {
    this.lockout = false;
    Toast.showError(e);
    return Promise.reject(e);
  });
};

List.prototype.clearList = function () {  
  this.clearItems();
};

List.prototype.clearItems = function () {
  Vue.set(this, 'items', []);
  Vue.set(this, 'loaded', false);
  Vue.set(this, 'lockout', false);
  Vue.set(this, 'noMoreItems', false);
};

List.prototype.scrolled = function (params) {
  this.scrollTop = params.scroller.scrollTop;
  if (this.lockout) return;
  if (this.noMoreItems || this.items.length === 0) {
    return Promise.resolve(false);
  }
  
  if (this.flip && params.scroller.scrollTop < 150) {
    return this.loadMore({ scroller: params.scroller, vm: params.vm })
    .then(data => {
      return true;
    });
  }
  else if (!this.flip && params.scroller.scrollTop + params.scroller.clientHeight + 150 >= params.scroller.scrollHeight) {
    return this.loadMore({ scroller: params.scroller, vm: params.vm });
  }
  else {
    return Promise.resolve(false);
  }
};

List.prototype.loadMore = function (params) {

  var listParams = {
    ...params,
    before: this.items[this.items.length - 1]
  };

  return this.loadList(listParams);
};

List.prototype.updateItem = function (item) {
 
  for (var i = 0; i < this.items.length; ++i) {
    if (item === this.items[i]) {
      Vue.set(this.items, i, item);
      break;
    }
  }
};

List.prototype.addItem = function (item, params) {
  params = params || {};

  var items = [...this.items];
  var found = false;
  for (var i = 0; i < items.length; ++i) {
    if (item === items[i]) {
      found = true;
      break;
    }
  }
  if (!found) {
    if (params.unshift) items.unshift(item);
    else items.push(item);
  }

  Vue.set(this, 'items', items);
}; 

List.prototype.removeItem = function (item) {
  for (var i = 0; i < this.items.length; ++i) {
    if (item === this.items[i]) {
      Vue.delete(this.items, i);
      if (!this.noMoreItems && this.items.length < this.limit) this.loadMore();
      else if (this.items.length === 0) {
        this.noMoreItems = true;
      }
      break;
    }
  }
};

List.prototype.sortList = function (sortFunction) {
  this.items.sort(sortFunction);
}

List.prototype.toFilter = function (filtersAndSorts) {
  
  var queryFilters  = {};
  var filters       = false;
  var search        = false;
  var sort          = filtersAndSorts.sort || false;

  if (filtersAndSorts.filtering) {
    filters = filtersAndSorts.filtering.filters || false;
    search  = filtersAndSorts.filtering.search  || false;
  }
  
  // Sort
  if (sort) {
    queryFilters['sort'] = sort.options[sort.value].value > 0 ? sort.value : '-' + sort.value;
  }

  // Filters
  if (filters) {
    for (var key in filters) {
      if (filters[key].value && filters[key].value !== 'all') {
        queryFilters[key] = filters[key].value;
      }
    }
  }

  // Search
  if (search) {
    queryFilters['search'] = search.value;
  }

  return queryFilters;
}

module.exports = List;



// WEBPACK FOOTER //
// ./src/scripts/list.js